import { render } from "./ShipmentOrders.vue?vue&type=template&id=79344f8d&scoped=true"
import script from "./ShipmentOrders.vue?vue&type=script&lang=js"
export * from "./ShipmentOrders.vue?vue&type=script&lang=js"

import "./ShipmentOrders.vue?vue&type=style&index=0&id=79344f8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79344f8d"]])

export default __exports__